import { Link as RouterLink } from "react-router-dom";
import { isEmpty } from "../../../../utils/utils";
import { MERGER_ARBITRAGE } from "../../../../utils/constants";


export default function IndexRow({ index, statistics }) {
  return (
    <tr className="family-table-row family-table-row-gray">
      <td style={{padding: '5px'}} >
        {index.id === MERGER_ARBITRAGE ? (
          <RouterLink
            to={`/index/alphabeta-merger-arbitrage-index`}
            className="family-table-link"
          >
            <bdi>{index.name}</bdi>
          </RouterLink>
        ) : (
          <RouterLink to={`/index/${index.id}`} className="family-table-link">
            <bdi>{index.name}</bdi>
          </RouterLink>
        )}
      </td>
      <td dir="ltr" className="family-table-cell">
        {isEmpty(statistics) ? "-" : (statistics["1_day"] * 100).toFixed(2)}
      </td>
      <td dir="ltr" className="family-table-cell">
        {isEmpty(statistics)
          ? "-"
          : (statistics["beginning_of_year"] * 100).toFixed(2) || "-"}
      </td>
      <td dir="ltr" className="family-table-cell">
        {isEmpty(statistics) ? "-" : (statistics["1y"] * 100).toFixed(2) || "-"}
      </td>
      <td dir="ltr" className="family-table-cell">
        {isEmpty(statistics) ? "-" : (statistics["3y"] * 100).toFixed(2) || "-"}
      </td>
      <td dir="ltr" className="family-table-cell">
        {isEmpty(statistics) ? "-" : (statistics["5y"] * 100).toFixed(2) || "-"}
      </td>
      <td dir="ltr" className="family-table-cell">
        {isEmpty(statistics)
          ? "-"
          : (statistics["10y"] * 100).toFixed(2) || "-"}
      </td>
      <td dir="ltr" className="family-table-cell">
        {isEmpty(statistics)
          ? "-"
          : (statistics["15y"] * 100).toFixed(2) || "-"}
      </td>
    </tr>
  );
}
